module.exports = __webpack_public_path__ + "media/stich.20aded14.wav";